import type { TOC } from '@ember/component/template-only'

interface Signature {
  Element: HTMLTableCellElement
  Blocks: {
    default: []
  }
}

export const ThStandard: TOC<Signature> = <template>
  <th class="p-3 font-semibold" ...attributes>{{yield}}</th>
</template>

export default ThStandard
